import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackEarlyAccessBannerClick, trackEarlyAccessBannerShow } from './tracking';
import { EarlyAccessBanner } from '../../components/EarlyAccessBanner';
import { selectEarlyAccessData, selectEarlyAccessUrl } from '../../selectors/earlyAccess';

export const EarlyAccessBannerContainer = () => {
  const earlyAccessData = useSelector(selectEarlyAccessData);
  const listingWithEarlyAccessOffersUrl = useSelector(selectEarlyAccessUrl);

  /* istanbul ignore next */
  if (!earlyAccessData) {
    return null;
  }

  return (
    <ActionAfterViewObserver triggerOnce callback={trackEarlyAccessBannerShow}>
      <EarlyAccessBanner
        {...earlyAccessData}
        listingUrl={listingWithEarlyAccessOffersUrl}
        onLinkClick={trackEarlyAccessBannerClick}
      />
    </ActionAfterViewObserver>
  );
};
